import React from 'react';
import OrderDetailSection from './OrderDetailSection/OrderDetailSection';

import CallContainer from '../../components/CallContainer';

const SlottedOrdersLayout = () => {
  return (
    <>
      <OrderDetailSection />
      <CallContainer />
    </>
  );
};

export default SlottedOrdersLayout;
